import {combineReducers} from 'redux';
import ajaxCallInProgress from './ajaxStatusReducer';
import tag from './tagReducer';
import strings from './stringsReducer';
import showSidebarIzquierda from './showSidebarIzquierdaReducer';
import sidebarIzquierda from './sidebarIzquierdaReducer';
import user from './userReducer';
import fotoPerfil from './fotoPerfilReducer';
import idioma from './idiomaReducer';
import contenido from './contenidoReducer';
import contenidoCombo from './contenidoComboReducer';
import tipoContenidoCombo from './tipoContenidoComboReducer';
import tagCombo from './tagComboReducer';
import formulario from './formularioReducer';
import formularioCombo from './formularioComboReducer';
import preguntarespuesta from './preguntarespuestaReducer';
import preguntarespuestaCombo from './preguntarespuestaComboReducer';
import moduloCombo from './moduloComboReducer';
import modulo from './moduloReducer';
import curso from './cursoReducer';
import cursoCombo from './cursoComboReducer';
import tablas from './tablasReducers';
import usuarioCombo from './usuarioComboReducer';
import usuario from './usuarioReducer';
import roleCombo from './roleComboReducer';
import cursoCarrusel from './cursoCarruselReducer';
import cursoGratuitos from './cursoGratuitosReducer';
import preguntaCombo from './preguntaComboReducer';
import pregunta from './preguntaReducer';
import respuesta from './respuestaReducer';
import respuestaCombo from './respuestaComboReducer';
import insigniaCombo from './insigniaComboReducer';
import insignia from './insigniaReducer';
import homeInfo from './homeInfoReducer';
import instructores from './instructoresReducer';
import preguntasfrecuentes from './preguntasfrecuentesReducer';
import preguntasFrecuentesHome from './preguntasFrecuentesHomeReducer';
import menu from './menuReducer';
import resultadoexamen from './resultadoexamenReducer';
import resultadoexamenCombo from './resultadoexamenComboReducer';
import comentarios from './comentariosReducer';
import comentariosCombo from './comentariosComboReducer';
import cursoaprendizajeCombo from './cursoaprendizajeComboReducer';
import cursoaprendizaje from './cursoaprendizajeReducer';
import inscripcion from './inscripcionReducer';
import inscripcionCombo from './inscripcionComboReducer';
import cursoopinion from './cursoopinionReducer';
import cursoopinionCombo from './cursoopinionComboReducer';
import showModalAvisoFinSession from './avisoFinSessionReducer';
import cursoconstancia from './cursoconstanciaReducer';
import cursoconstanciaCombo from './cursoconstanciaComboReducer';
import pagosCombo from './pagosComboReducer';
import pagos from './pagosReducer';
import referenciabancaria from './referenciabancariaReducer';
import referenciabancariaCombo from './referenciabancariaComboReducer';
import tipomoneda from './tipomonedaReducer';
import tipomonedaCombo from './tipomonedaComboReducer';
import cursotipomoneda from './cursotipomonedaReducer';
import cursotipomonedaCombo from './cursotipomonedaComboReducer';
import crucigrama from './crucigramaReducer';
import crucigramaCombo from './crucigramaComboReducer';
import crucigramapalabras from './crucigramapalabrasReducer';
import crucigramapalabrasCombo from './crucigramapalabrasComboReducer';
import usuariocursoCombo from './usuariocursoComboReducer';
import usuariocurso from './usuariocursoReducer';
import paginaActual from './paginaActualReducer';
import pagoReporte from './pagoReporteReducer';
import contablecuentaCombo from './contablecuentaComboReducer';
import contablecuenta from './contablecuentaReducer';
import contablegastoCombo from './contablegastoComboReducer';
import contablegasto from './contablegastoReducer';
import contableregistrogastoCombo from './contableregistrogastoComboReducer';
import contableregistrogasto from './contableregistrogastoReducer';
import paisCombo from './paisComboReducer';
import pais from './paisReducer';
import ciudad from './ciudadReducer';
import region from './regionReducer';
import ciudadCombo from './ciudadComboReducer';
import regionCombo from './regionComboReducer';
import cursoTipoCombo from './cursoTipoComboReducer';
import descuento from './descuentoReducer';
import descuentoCombo from './descuentoComboReducer';

const rootReducers=combineReducers({
    insignia,
    showModalAvisoFinSession,
    preguntasFrecuentesHome,
    preguntasfrecuentes,
    menu,
    instructores,
    cursoGratuitos,
    homeInfo,
    ajaxCallInProgress,
    insigniaCombo,
    cursoCarrusel,
    usuario,
    roleCombo,
    tag,
    usuarioCombo,
    cursoCombo,
    curso,
    strings,
    tablas,
    showSidebarIzquierda,
    sidebarIzquierda,
    user,
    modulo,
    contenido,
    contenidoCombo,
    tipoContenidoCombo,
    tagCombo,
    idioma,
    formulario,
    formularioCombo,
    preguntarespuesta,
    preguntarespuestaCombo,
    moduloCombo,
    preguntaCombo,
    pregunta,
    respuesta,
    respuestaCombo,
    resultadoexamen,
    resultadoexamenCombo,
    fotoPerfil,
    comentariosCombo,
    comentarios,
    cursoaprendizajeCombo,
    cursoaprendizaje,
    inscripcion,
    inscripcionCombo,
    cursoopinion,
    cursoopinionCombo,
    cursoconstancia,
    cursoconstanciaCombo,   
    pagosCombo,
    pagos,
    referenciabancariaCombo,
    referenciabancaria,
    tipomoneda,
    tipomonedaCombo,
    cursotipomoneda,
    cursotipomonedaCombo,
    crucigrama,
    crucigramaCombo,
    crucigramapalabras,
    crucigramapalabrasCombo,
    usuariocursoCombo,
    usuariocurso,
    paginaActual,
    pagoReporte,
    contablecuentaCombo,
    contablecuenta,
    contablegastoCombo,
    contablegasto,
    contableregistrogastoCombo,
    contableregistrogasto,
    paisCombo,
    pais,
    ciudad,
    region,
    ciudadCombo,
    regionCombo,
    cursoTipoCombo,
    descuento,
    descuentoCombo
});

export default rootReducers;
